import React from 'react';
import styled from 'styled-components';

import { getTheme } from '../../util/theme';

const FooterStyles = styled.footer`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin-bottom: ${getTheme('doubleSpace')};

  p {
    border: 1px solid ${getTheme('darkBlue')};
    padding: ${getTheme('halfSpace')};
    text-align: center;
  }
`;

export const Footer = () => (
  <FooterStyles role="contentinfo">
    <p>
      Paid for by the Pennsylvania Senate Democratic Campaign Committee.<br />
      Powered by Tech for Campaigns.
    </p>
  </FooterStyles>
);



// WEBPACK FOOTER //
// ./src/components/Shared/Footer.js